import UserPhotoCard from 'screens/Users/components/UserPhotoCard'
import TopNavigationLayoutPageContent from '../../shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import GeneralInfoCard from './components/SelfGeneralInfoCard'
import SelfSkillsCard from './components/SelfSkillsCard'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'
import UserProjectsCard from 'screens/Users/components/UserProjectsCard'
import selfProjectsAtom from 'screens/Auth/components/InitProvider/selfProjects.atom'
import useSelfActiveProject from 'screens/Projects/hooks/useSelfActiveProject'

const Profile = () => {
  const userId = useRecoilValue(authAtom).user.id
  const selfProjects = useRecoilValue(selfProjectsAtom)
  const activeProject = useSelfActiveProject()

  const archivedProjects = useMemo(
    () => selfProjects.items.filter((p) => p.id !== activeProject?.id),
    [selfProjects.items, activeProject?.id]
  )

  return (
    <TopNavigationLayoutPageContent type='default'>
      <div className='inline-flex-gap' style={{ gap: '32px' }}>
        <h2 className='text--heading-h4' style={{ flexShrink: 0 }}>
          Профиль
        </h2>
      </div>
      <div className='flex-lines gap24'>
        <div className='inline-flex-gap gap24' style={{ width: '100%' }}>
          <UserPhotoCard userId={userId} />
          <div style={{ width: '100%' }}>
            <GeneralInfoCard />
          </div>
        </div>
        <SelfSkillsCard />
        <UserProjectsCard projects={archivedProjects} />
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default Profile
